import { connect } from 'react-redux';
import { selectors } from 'app-webtech-core';
import { AuthenticationDialogComponent } from '../components/AuthenticationDialog';
import { getPrettyName } from '../helpers/getPrettyName';

const mapStateToProps = (state, ownProps) => {
  const { error } = selectors.userAccount.properties(state);
  const errorDetails = (error && error.response) || [];
  const user = selectors.userAccount.properties(state).data || {};
  let errors;

  // add special handling of change-password API err res (object)
  if (!Array.isArray(errorDetails)) {
    errors = { currentPassword: errorDetails.error };
  } else {
    // all other err res returned as an array
    errors = errorDetails.reduce(
      (obj, row) => ({
        ...obj,
        [row.param === 'login' ? 'password' : row.param]: row.msg,
      }),
      ownProps.errors || {},
    );
  }

  return {
    errors: errors,
    isAuthenticated: selectors.userAccount.isAuthenticated(state),
    user,
    userName: getPrettyName(user),
  };
};

export const AuthenticationDialog = connect(mapStateToProps)(AuthenticationDialogComponent);
